let validationMixin = {
  methods: {
    checkEmpty(value) {
      //console.log('checkEmpty valuevaluevaluevaluevaluevalue = ', value);
      return !this.$util.isEmpty(value) || '';
    },
    checkNumber(value, limit, model, key) {
      var regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택하는 정규식
      if (model != null) {
        this.$nextTick(() => {
          let tmpValue = value.replace(regex, '');
          if (Number(tmpValue) > limit) {
            tmpValue = limit;
          }
          model[key] = String(tmpValue);
        });
      }
    },
    // checkIP(value, model, key) {
    //     if (model != null) {
    //         this.$nextTick(() => {
    //             /* eslint-disable */
    //             var regex = /^([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
    //             /* eslint-enable */
    //             let valueArr = value.includes('.') ? value.split('.') : [value];
    //           //console.log('1111111111111 valueArr = ', valueArr);
    //             let result = '';
    //             for (let i = 0; i < valueArr.length && i < 4; i++) {
    //                 let item = valueArr[i];
    //                 for (let j = item.length; j > 0; j--) {
    //                     let tmp = item.slice(0, j);
    //                     if (regex.test(tmp)) {
    //                         result += tmp;
    //                         if (i < valueArr.length - 1 && i < 3) result += '.';
    //                         break;
    //                     }
    //                 }
    //             }
    //           //console.log('1111111111111 result = ', result);
    //             model[key] = result;
    //         });
    //     } else {
    //         return this.$util.isIp(value) || this.$p('validation.isIp');
    //     }
    // },
    checkIPnew(value, model, key) {
      if (value) {
        if (model != null) {
          if (value.length > 15) {
            this.$nextTick(() => {
              model[key] = value.slice(0, 15);
            });
          }
        }
        let strs = value.split('.');
        strs = strs.filter((d, i) => i < 4).filter((d, i) => i !== 0 && strs[i - 1].length === 0 ? false : true).map((n) => {
          return n.length === 4 ? n.toString().slice(0, 3) : Number(n) > 255 ? n.toString().slice(0, 2) : n;
        });
        this.$nextTick(() => {
          model[key] = strs.join('.').replace(/[^0-9.]/g, '');
        });
      }

    },
    checkIP(value, ref) {
      //console.log(value,ref);
      if (value && value.length > 15) {
        this.$nextTick(() => {
          ref.txtField = value.slice(0, 15);
        });
      }
      let strs = value.split('.');
      strs = strs.filter((d, i) => i < 4).filter((d, i) => i !== 0 && strs[i - 1].length === 0 ? false : true).map((n) => {
        return n.length === 4 ? n.toString().slice(0, 3) : Number(n) > 255 ? n.toString().slice(0, 2) : n;
      });
      this.$nextTick(() => {
        ref.txtField = strs.join('.').replace(/[^0-9.]/g, '');
        ref.blur();
        ref.focus();
      });
    },
    checkPort(value, model, key) {
      var regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택하는 정규식
      if (model != null) {
        this.$nextTick(() => {
          model[key] = value.replace(regex, '');
          if (!this.$util.isPort(value)) {
            model[key] = value.substring(0, value.length - 1);
          }
        });
      } else {
        return this.$util.isPort(value) || this.p('validation.isPort');
      }
    },
    checkEng(value, model, key) {
      var regex = /[^a-zA-Z]/g; // 영문이 아닌 문자열을 선택하는 정규식
      if (model != null) {
        this.$nextTick(() => {
          model[key] = value.replace(regex, '');
        });
      } else {
        return value;
      }
    },
    checkByte(value, limit, model, key) {
      if (model != null) {
        this.$nextTick(() => {
          if (this.$util.isOverByte(value, limit)) {
            model[key] = this.$util.substringByByte(value, limit);
          }
        });
      } else {
        //return !this.$util.isOverByte(value, limit) || this.$p('validation.textExceeded')
      }
    },
    checkMaxLength(value, limit, model, key) {
      if (model != null) {
        this.$nextTick(() => {
          if (value || ''.length > limit) {
            model[key] = value.slice(0, limit);
          }
        });
      } else {
        return value.length == 0 || value.length <= limit || `최대 ${limit}자`;
      }
    }
  }
};
export default validationMixin;
